// Angular
import { Component, OnInit, Inject, ViewEncapsulation, ViewChild } from '@angular/core';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
// Services and Models
import { PatientDevice } from '../../../../../../../../core/lists';
import { PatientVitalsViewDialogComponent } from '../patient-vitals-view/patient-vitals-view.dialog.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-patient-device-view-dialog',
  templateUrl: './patient-device-view.dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class PatientDeviceViewDialogComponent implements OnInit {
  // Public properties
  patientDevice: PatientDevice;
  form: any;
  form_data: any;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = ['patient_vital_id', 'capture_date', 'alert', 'view'];

  /**
   * Component constructor
   *
   * @param data: any
   * @param dialogRef: MatDialogRef<PatientDeviceEditDialogComponent>
   * @param translate: TranslateService
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PatientDeviceViewDialogComponent>,
    private translate: TranslateService,
  ) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit() {
    this.patientDevice = this.data.patientDevice;
    this.form = JSON.parse(this.data.form);
    this.form_data = { data: JSON.parse(this.patientDevice.patient_range) };
    this.dataSource = new MatTableDataSource(this.patientDevice.patient_vitals_dto);
    this.dataSource.paginator = this.paginator;
  }

  /**
   * Retursn CSS Class Name by alert status
   *
   * @param alert: boolean
   */
  getItemCssClassByAlertStatus(alert: boolean): string {
    return alert ? 'danger' : 'success';
  }

  /**
   * Returns Alert Status in string
   * @param alert: boolean
   */
  getAlertString(alert): string {
    return alert
      ? this.translate.instant('PATIENT_DEVICE.VIEW_DEVICE.ALERT')
      : this.translate.instant('PATIENT_DEVICE.VIEW_DEVICE.NO_ALERTS');
  }

  viewVitals(vitals) {
    this.dialog.open(PatientVitalsViewDialogComponent, { data: { vitals } });
  }
}
